import React, { useRef, useEffect } from "react";

export default function MessageBox({
	message,
	isSuccess,
	isLoading,
}: {
	message: string | null;
	isSuccess: boolean;
	isLoading: boolean;
}) {
	const messageRef = useRef<HTMLDivElement>(null);

	// Scroll vers le message d'erreur quand il apparaît
	useEffect(() => {
		if (message && !isSuccess && !isLoading && messageRef.current) {
			messageRef.current.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
		}
	}, [message, isSuccess, isLoading]);

	if (isLoading || !message) {
		return null;
	}

	return (
		<div
			ref={messageRef}
			className={[
				"gext-form__message",
				isSuccess
					? "gext-form__message--success"
					: "gext-form__message--error",
			].join(" ")}
			role="alert"
			aria-live="polite"
		>
			{message}
		</div>
	);
}
